import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { VideoCamera, WifiMedium, Clock } from "@phosphor-icons/react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LiveRoom, fmtDateTime } from "@/components/LiveClass";

/** Page publique (sans compte) ouverte depuis un lien d'invitation généré par un enseignant. */
export default function InviteVisio() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [name, setName] = useState("");
  const [low, setLow] = useState(false);
  const [room, setRoom] = useState(null);
  const [left, setLeft] = useState(false);

  const load = () => api.get(`/public/live/${token}`).then((r) => { setInfo(r.data); setError(""); }).catch((e) => setError(apiError(e)));
  useEffect(() => { load(); }, [token]);

  if (room) {
    return <LiveRoom session={{ id: "guest", title: info?.title || "Visio", course_title: info?.course_title }} guest={{ token, name: room.name }} lowBandwidth={low} onClose={() => { setRoom(null); setLeft(true); }} />;
  }
  const open = info?.status === "ouverte";
  return (
    <div className="grid min-h-screen place-items-center bg-background p-4" data-testid="invite-page">
      <div className="w-full max-w-md space-y-5 rounded-2xl border border-border bg-card p-6 shadow-sm">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent">ECL Abidjan · Visioconférence</p>
          <h1 className="mt-1 font-display text-2xl font-extrabold leading-tight">{info ? info.title : "Invitation"}</h1>
          {info && <p className="text-sm text-muted-foreground">{info.course_title}</p>}
        </div>
        {error && <p className="rounded-lg bg-destructive/10 p-3 text-sm text-destructive" data-testid="invite-error">{error}</p>}
        {left && <p className="rounded-lg bg-muted p-3 text-sm">Vous avez quitté la salle. Vous pouvez y revenir avec le même lien tant que la séance est ouverte.</p>}
        {info && (
          <>
            <p className="flex items-center gap-1 text-sm text-muted-foreground"><Clock size={14} /> <span className="capitalize">{fmtDateTime(info.start_at)}</span> · {info.duration_min} min</p>
            {info.status === "terminee" && <p className="text-sm font-semibold">Cette séance est terminée.</p>}
            {info.status === "planifiee" && <p className="text-sm">La salle ouvrira 15 minutes avant le début. Revenez sur ce lien à ce moment-là.</p>}
            {!info.enabled && <p className="text-sm text-amber-700">La visioconférence n'est pas disponible pour le moment.</p>}
            {open && info.enabled && (
              <div className="space-y-4">
                <div>
                  <Label>Votre nom</Label>
                  <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Prénom et nom" maxLength={60} data-testid="invite-name" />
                </div>
                <label className="flex cursor-pointer items-start gap-3 rounded-lg border border-border p-3">
                  <input type="checkbox" className="mt-1 h-4 w-4" checked={low} onChange={(e) => setLow(e.target.checked)} />
                  <span>
                    <span className="flex items-center gap-1 text-sm font-semibold"><WifiMedium size={16} /> Connexion lente ? Mode économe</span>
                    <span className="block text-xs text-muted-foreground">Caméra coupée et image réduite.</span>
                  </span>
                </label>
                <Button className="w-full bg-accent hover:bg-accent/90" disabled={name.trim().length < 2} onClick={() => setRoom({ name: name.trim() })} data-testid="invite-join">
                  <VideoCamera size={18} className="mr-2" weight="fill" /> Entrer dans la salle
                </Button>
              </div>
            )}
            {info.status !== "terminee" && !open && <Button variant="outline" className="w-full" onClick={load}>Actualiser</Button>}
          </>
        )}
      </div>
    </div>
  );
}
